import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Icons} from '../ArticlePagesBlock/Icons';
import {Tags} from '../ArticlePagesBlock/Tags';
import {AdditionalArticles} from '../ArticlePagesBlock/AdditionalArticles';
import {
  getFullPath,
  extractIconElements,
  extractTagsElements,
  iframeScreenAdjustment,
  extractAdditionalArticlesTvElements,
} from '../ArticlePagesBlock/utilities';

export const ArticlePagesTvBlockMain = (props) => {
  const content = {
    backgroundImg: isMobile
      ? getFullPath(props.contentData?.backgroundImageMobile?.value?.url)
      : getFullPath(props.contentData?.backgroundImageDesktop?.value?.url),
    mainHeading: props.contentData?.mainHeading?.value,
    secondaryHeading: props.contentData?.secondaryHeading?.value,
    iconsList: extractIconElements(props.contentData?.socialNetworksIconsDataList?.expandedValue),
    tagsList: extractTagsElements(props.contentData?.tagsDataList?.expandedValue),
    articleContent: isMobile
      ? iframeScreenAdjustment(props.contentData?.articleContent?.value, 'width="339px" height="175px"')
      : iframeScreenAdjustment(props.contentData?.articleContent?.value, 'width="612px" height="409px"'),
    showAdditionalArticles: props.contentData?.showAdditionalArticles?.value,
    additionalArticles: extractAdditionalArticlesTvElements(props.contentData?.additionalArticles?.expandedValue),
  };

  const showAdditionalArticles=content.showAdditionalArticles && content.additionalArticles;
  const [desktopArticles, setDesktopArticles] = useState(content.additionalArticles?.slice(0, 3) || []);
  const [additionalBtnText, setBtnText] = useState('כתבות נוספות');
  const [showAdditional, setAdditionalDisplay] = useState(false);

  const handleMoreArticlesClick = () => {
    if (showAdditional) {
      setDesktopArticles(content.additionalArticles);
      setBtnText('חזרה לכתבות נבחרות');
    } else {
      setDesktopArticles(content.additionalArticles.slice(0, 3));
      setBtnText('כתבות נוספות');
    }
  };

  return (
    <div className={isMobile ? 'article-pages-tv-block-mobile' : 'article-pages-tv-block'}>
      <div className='article-pages-header'>
        <div className='upper-page-container'>
          <div className='page-info-container'>
            <div className='page-info'>
              <span className='main-heading' dangerouslySetInnerHTML={{__html: content.mainHeading}} />
              <span className='secondary-heading' dangerouslySetInnerHTML={{__html: content.secondaryHeading}} />
              {content.tagsList?.length>0 && <div className='tags-container'>
                <Tags tagList={content.tagsList?.reverse()} context={props.context} />
              </div>}
              {content.iconsList?.length>0 &&<div className='icons-container'>
                <Icons iconList={content.iconsList?.reverse()} />
              </div>}
            </div>
          </div>

          <div className='page-pic-container'>
            <Image className='page-pic' src={content.backgroundImg} />
          </div>
        </div>
        <div className='article-content-container'>
          <p className='article-content' dangerouslySetInnerHTML={{__html: content.articleContent}} />
        </div>
      </div>
     {showAdditionalArticles && content.additionalArticles?.length>0 &&  (
        <div className='additional-articles-section-container'>
          <div className='horizontal-line'></div>
          <div className='heading'>כתבות נוספות</div>
          <div className={desktopArticles.length>1?'additional-articles-container':'additional-articles-container single-element'}>
            {!isMobile ? (
              desktopArticles?.reverse().map((element, i) => {
                return <AdditionalArticles element={element} key={i} context={props.context} />;
              })
            ) : (
              <Swiper
                spaceBetween={5}
                centeredSlides
                slidesPerView={ desktopArticles.length>1 ? 1.2 : 1}
                pagination={{clickable: true}}
                className='d-block d-md-none'
                style={{paddingTop: '10px', paddingBottom: '10px'}}>
                {content.additionalArticles?.reverse().map((element, i) => (
                  <SwiperSlide key={i}>
                    <AdditionalArticles element={element} key={i} context={props.context} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
          {!isMobile && content.additionalArticles?.length > 3 && (
            <BtnWhiteBlackBorderBigSize
              onclick={() => {
                setAdditionalDisplay(!showAdditional);
                handleMoreArticlesClick();
              }}
              text={additionalBtnText}
            />
          )}
        </div>
      )}
    </div>
  );
};
